//#region src/utils/execute-with-concurrency-limit.ts
async function e(e, t) {
	let n = [], r = [];
	for (let [i, a] of e.entries()) {
		let e = a().then((e) => {
			n[i] = {
				status: "fulfilled",
				value: e
			};
		}).catch((e) => {
			n[i] = {
				status: "rejected",
				reason: e
			};
		}).then(() => {
			let t = r.indexOf(e);
			t !== -1 && r.splice(t, 1);
		});
		r.push(e), r.length >= t && await Promise.race(r);
	}
	return await Promise.all(r), n;
}
//#endregion
export { e as executeWithConcurrencyLimit };
